export default "__VITE_ASSET__BN23kpsa__"